import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShopContext } from '../../context/shopContext';

import './navbar.css';

import userLoggedIn from '../assets/user-solid.svg';
import userLoggedOut from '../assets/user-regular.svg';
import favsIcon from '../assets/heart-white.svg';
import search from '../assets/search.svg';
import logo from '../assets/branding/thumb_2logo.png';
import bag from '../assets/bag-shopping-solid.svg';
import burger from '../assets/bars-solid.svg';
import BurgerMenu from '../burgerMenu/burgerMenu';

const Navbar = () => {
    const { cartItems, favourites, accountData } = useContext(ShopContext);
    const cartCounter = cartItems?.length || 0;
    const favs = favourites?.length || 0;
    const [burgerMenu, setBurgerMenu] = useState(false);

    // Check if the user is logged in
    const isLoggedIn = Boolean(localStorage.getItem("Bearer"));

    return (
        <div className="navbar">
            <div className="navbar-main">
                <div className="nav-logo">
                    <Link to="/">
                        <img className="logo-img" src={logo} alt="Logo" />
                    </Link>
                </div>
                <div className="search-bar">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search here... duh!"
                    />
                    <button>
                        <img src={search} className="search-icon" alt="Search" />
                    </button>
                </div>
                <div className="nav-login-cart">
                    {isLoggedIn ? (
                        <div className='main-menu'>
                            <Link to="/account">
                                <img src={userLoggedIn} className="icons" alt="User" />
                                <p>Hi, {accountData?.user?.name || "User"}</p>
                            </Link>
                        </div>
                    ) : (
                        <div className='main-menu'>
                            <Link to="/login">
                                <img src={userLoggedOut} className="icons" alt="Login" />
                                <p>Login</p>
                            </Link>
                        </div>
                    )}
                    <div className='main-menu'>
                        <div className="nav-cart-count">{favs}</div>
                        <Link to="/favourites">
                            <img src={favsIcon} className="icons" alt="Favourites" />
                            <p>Saved</p>
                        </Link>
                    </div>
                    <div className='main-menu'>
                        <div className="nav-cart-count">{cartCounter}</div>
                        <Link to="/cart">
                            <img className="icons" src={bag} alt="Cart" />
                            <p>Basket</p>
                        </Link>
                    </div>

                    {/* Burger Menu Icon */}
                    <div onClick={() => setBurgerMenu(true)} className='burger-container'>
                        <img className="icons" src={burger} alt="Burger menu icon" />
                        <p>Menu</p>
                    </div>
                </div>
            </div>
            <div className="nav-menu">
                <ul>
                    <Link to="/all"><li>Shop All</li></Link>
                    <Link to="/birthday"><li>Birthdays</li></Link>

                    <Link to="/wedding"><li>Weddings</li></Link>
                    <Link to="/engagement"><li>Engagements</li></Link>

                </ul>
            </div>

            {/* Burger Menu Component */}
            <BurgerMenu isOpen={burgerMenu} onClose={() => setBurgerMenu(false)} />
        </div>
    );
};

export default Navbar;
